import ExamBuilder from "../../components/exam/ExamBuilder";
import PageMeta from "../../components/common/PageMeta";
import React from "react";

export default function CreateExam() {
    return (
        <div>
            <PageMeta title="Tạo/Cập nhật bài thi" description="Tạo/Cập nhật bài thi"/>
            <div className="container mx-auto max-w-4xl mb-4">
                <h1>Exam Builder</h1>
            </div>
            <ExamBuilder />
        </div>
    );
}